export const red = "#E60028";
export const blue = "#05235F";
export const grey = "#E1E1E1";
export const white = "#fff";
export const darkGrey = "#b6b6b6";

const colors = { red, blue, grey, darkGrey, white };

export default colors;
